/**
 * Bouton de retour en haut de page
 */
document.addEventListener('DOMContentLoaded', function() {
  // Créer le bouton
  const backToTopButton = document.createElement('button');
  backToTopButton.className = 'back-to-top';
  backToTopButton.setAttribute('aria-label', 'Retour en haut de page');
  backToTopButton.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="#581e1c" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path d="M7 14 L12 9"></path>
      <path d="M12 9 L17 14"></path>
    </svg>
  `;
  
  // Ajouter le bouton au body
  document.body.appendChild(backToTopButton);
  
  // Fonction pour afficher/masquer le bouton
  function toggleBackToTop() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    
    // Afficher le bouton après avoir scrollé d'une hauteur d'écran
    if (scrollTop > windowHeight * 0.5) {
      backToTopButton.classList.add('show');
    } else {
      backToTopButton.classList.remove('show');
    }
  }
  
  // Fonction pour remonter en haut
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  
  // Gérer le clic sur le bouton
  backToTopButton.addEventListener('click', scrollToTop);
  
  // Gérer le scroll avec throttle pour optimiser les performances
  let scrollTimer = null;
  window.addEventListener('scroll', function() {
    if (scrollTimer !== null) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(function() {
      toggleBackToTop();
    }, 150);
  });
  
  // Vérifier l'état initial
  toggleBackToTop();
});